import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from "vue-i18n";
import HoModalDialog from "@/components/modal/ho-modal-dialog.vue";
import CreateOrganizationForm from "./createOrganizationForm/index.vue";
import IOrganization, {
	ICreateOrganizationData,
	IUpdateOrganizationData,
} from "@/interfaces/organizations/iOrganization";


export default /*#__PURE__*/_defineComponent({
  __name: 'create-organization-dialog',
  props: {
	loading: Boolean,
	editMode: Boolean,
	organizationData: {
		type: Object as () => IOrganization,
	},
},
  emits: ["onSubmit", "onCancel"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const localization = useI18n();

const handleFormClose = (data?: ICreateOrganizationData | IUpdateOrganizationData) => {
	data ? emit("onSubmit", data) : emit("onCancel");
};

const handleModalCancel = () => {
	emit("onCancel");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HoModalDialog, {
    headerText: _unref(localization).t(__props.editMode
			? 'administration.organizations.edit-dialog-title'
			: 'administration.organizations.create-dialog-title'),
    "hide-footer": true,
    width: 480,
    onOnCancel: handleModalCancel
  }, {
    body: _withCtx(() => [
      _createVNode(CreateOrganizationForm, {
        loading: __props.loading,
        "edit-mode": __props.editMode,
        "organization-data": __props.organizationData,
        onOnClose: handleFormClose
      }, null, 8, ["loading", "edit-mode", "organization-data"])
    ]),
    _: 1
  }, 8, ["headerText"]))
}
}

})